import LandingLayout from "@/packages/Landing/view/LandingLayout.vue";
import Landing from "@/packages/Landing/components/Landing.vue";
const LandingRoutes =[
    {
        path: '/',
        component: LandingLayout,
        name: "LandingLayout",
        children: [
            {
                path: '/',
                component: Landing,
                name: "Landing",
            }
        ]
    }
];
export default LandingRoutes;
